import axios from 'axios'
import qs from 'qs'
import until from './until.js'

function authHeaders(contentType) {
    const token = until.getCookie('jwt_token') || ''
    const headers = token ? {
        Authorization: `Bearer ${token}`,
        signature: token
    } : {}
    if (contentType) headers['Content-Type'] = contentType
    return headers
}

function errorMessage(error) {
    const data = error && error.response ? error.response.data : null
    if (data && typeof data === 'object') return data.msg || data.errmsg || '请求失败'
    if (typeof data === 'string') {
        try {
            const parsed = JSON.parse(data)
            return parsed.msg || parsed.errmsg || '请求失败'
        } catch (e) {
            return '请求失败'
        }
    }
    return '网络连接失败，请稍后重试'
}

async function request(config) {
    try {
        const response = await axios(config)
        return response.data || { errcode: 1, errmsg: '响应数据为空' }
    } catch (error) {
        return {
            errcode: 1,
            status: error && error.response ? error.response.status : 0,
            errmsg: errorMessage(error)
        }
    }
}

function withAppId(appId, params) {
    return Object.assign({ app_id: appId || '' }, params || {})
}

export default {
    publicDevice(appId, deviceSn) {
        return request({
            method: 'get',
            url: '/api_nologin/sale_service/device_info',
            params: withAppId(appId, { device_sn: deviceSn }),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },
    createOrder(appId, data) {
        return request({
            method: 'post',
            url: '/api_nologin/sale_service/order',
            params: withAppId(appId),
            data: qs.stringify(data),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },
    listOrders(appId, params) {
        return request({
            method: 'get',
            url: '/api_nologin/sale_service/order/list',
            params: withAppId(appId, params),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },
    orderInfo(appId, id, deviceSn) {
        return request({
            method: 'get',
            url: '/api_nologin/sale_service/order/info',
            params: withAppId(appId, { id, device_sn: deviceSn }),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },
    uploadImage(appId, file, deviceSn) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('device_sn', deviceSn)
        return request({
            method: 'post',
            url: '/api_nologin/sale_service/upload',
            params: withAppId(appId),
            data: formData,
            headers: authHeaders()
        })
    },
    wechatStatus(appId) {
        return request({
            method: 'get',
            url: '/api_nologin/sale_service/wechat/status',
            params: withAppId(appId),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    },
    wechatJssdk(appId, pageUrl) {
        return request({
            method: 'post',
            url: '/api_nologin/wechat/jssdk',
            params: withAppId(appId),
            data: qs.stringify({ url: pageUrl }),
            headers: authHeaders('application/x-www-form-urlencoded')
        })
    }
}
